// extracted by mini-css-extract-plugin
export default {"loaderXSmall":"SUgXNr"};